import {Component, Inject, OnInit} from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { DialogData } from '@app/shared/models/dialog-data';


@Component({
    templateUrl: './system-id-dialog.component.html',
    styleUrls: ['./system-id-dialog.component.scss']
})
export class SystemIdDialogDialogComponent extends BaseWithBundleComponent
                                          implements OnInit {

    public clientID: string;

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                public dialogRef: MatDialogRef<DialogData>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        super(componentServiceBundle);
        this._idPrefix = 'system_id_dialog.';
    }

    public ngOnInit() {
        let client = this.authenticationService.currentUserValue.client;
        this.clientID = `DYC${client.id}`;
        this.data.title = `${client.companyname} (${this.translateService.instant(client.trans.customer_number)}: ${client.customer_number})`;
    }

    public close(): void {
        this.dialogRef.close(false);
    }

}
